import { useCallback, useEffect } from 'react'
import {
  aCheckedListings,
  aDrawnFeature,
  aHiddenListings,
  aPersistedFilters,
  aUser,
  useAtomValue,
  useSetAtom,
} from '~/atoms'
import { useRouteChange, useRouteMeta } from './useRouteChange'

export default function useResetMapState() {
  const user = useAtomValue(aUser)
  const subscribe = useRouteChange()
  const setDrawnFeature = useSetAtom(aDrawnFeature)
  const setCheckedListings = useSetAtom(aCheckedListings)
  const setHiddenListings = useSetAtom(aHiddenListings)
  const { getPreviousRouteMeta } = useRouteMeta()
  const setPersistedFilters = useSetAtom(aPersistedFilters)

  const onRouteChange = useCallback(
    (_prev: string | undefined, _next: string, isBack: boolean) => {
      const preserveMap = !!user?.options?.map?.preserve

      if (isBack || preserveMap) return

      const meta = getPreviousRouteMeta()
      const shouldReset =
        !('renderedMainMap' in meta) || meta.renderedMainMap !== true

      if (shouldReset) {
        setPersistedFilters(null)
        setHiddenListings([])
        setDrawnFeature(null)
        setCheckedListings([])
      }
    },
    [getPreviousRouteMeta]
  )

  useEffect(() => {
    const unsubscribe = subscribe(onRouteChange)

    return unsubscribe
  }, [subscribe, onRouteChange])
}
